export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./withdrawal-codes-list.vue?vue&type=template&id=4d6ed969"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/withdrawal-codes-list/withdrawal-codes-list.vue?vue&type=template&id=4d6ed969
// module id = bxt+
// module chunks = 0